import React, { useState, setState, useEffect } from "react";
import PropTypes from "prop-types";
import CheckboxSimple from "./CheckboxSimple";
import { getPropByLanguage } from "../../../../../utils/Language";
import Gender from "./Gender";
import Price from "./Price";
import { useApp } from "../../../../../contexts";

function FilterCharacter(props) {
  const { T, language } = useApp();
  const propLang = getPropByLanguage(language);
  const { setFilterData, filterData, categoryOptions } = props;

  // console.log("FilterAvatar->filterData", JSON.stringify({ filterData }));
  const [categoryOptionsLocal, $categoryOptionsLocal] = useState([]);
  const [giftTypesOptions, $giftTypesOptions] = useState([
    { value: "", title: "All" },
    { value: "1", title: "Use only" },
    { value: "0", title: "Tradeable" },
  ]);

  const [priceFrom, $priceFrom] = useState(filterData?.priceFrom);
  const [priceTo, $priceTo] = useState(filterData?.priceTo);
  const [animationIds, $animationIds] = useState(
    filterData?.animationIds || []
  );
  const [giftTypes, $giftTypes] = useState(filterData?.giftTypes || []);

  const onChangeCategory = (val) => {
    const data = val.map((v) => +v);
    $animationIds(data);
    setFilterData({
      animationIds: data,
    });
  };
  const onChangePrice = (val) => {
    $priceFrom(val.priceFrom);
    $priceTo(val.priceTo);
    setFilterData({
      priceFrom: val.priceFrom,
      priceTo: val.priceTo,
    });
  };
  const onChangeGiftType = (val) => {
    $giftTypes(val);
    setFilterData({
      giftTypes: val,
    });
  };
  useEffect(() => {
    console.log("categoryOptions", categoryOptions);
    if (categoryOptions.length > 0) {
      const translatedOptions = categoryOptions?.map((breed) => {
        return {
          title: T(`title.${breed.name.toLowerCase()}`),
          value: breed.id,
        };
      });
      $categoryOptionsLocal(translatedOptions);
    }
  }, [categoryOptions, propLang]);

  return (
    <div>
      <Gender
        title={T("Type")}
        name={"giftTypes"}
        options={giftTypesOptions}
        value={giftTypes}
        t={T}
        onChange={(val) => onChangeGiftType(val)}
      />
      <Price
        title={T("Price")}
        priceFrom={priceFrom}
        priceTo={priceTo}
        onChange={(val) => onChangePrice(val)}
      />
      <CheckboxSimple
        title={T("Animation included")}
        name={"animationIds"}
        options={categoryOptionsLocal}
        value={animationIds}
        isLastest={true}
        t={T}
        onChange={(val) => onChangeCategory(val)}
      />
    </div>
  );
}

FilterCharacter.propTypes = {
  setFilterData: PropTypes.func,
  filterData: PropTypes.object,
};

export default FilterCharacter;
